import styled from 'styled-components'
import { themeGet } from 'styled-system'
import theme from 'styles/theme'
import { Body12 } from 'components/Typography'

const Wrapper = styled(Body12)`
  color: ${themeGet('colors.red')};
  position: relative;
  padding-left: ${theme.space[5]};
  margin: ${theme.space[1]} 0;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 5px;
    padding: ${theme.space[1]} ${theme.space[5]};
    margin-top: 3px;
  }
`
export { Wrapper as default }
